export const localizationEn = {
  logout: 'Logout',
  retry: 'Retry',
  ND: 'N/D',
  actionErrors: {
    genericExecutionFailed: 'Could not complete the action',
    unsupportedActionButton: 'Action "{{actionCode}}" isn\'t supported on this button',
  },
  main: 'Main',
  views: {
    flightView: 'Flight View',
    resourceView: 'Resource View',
    taskView: 'Task View',
  },
  updateSettings: {
    websocket: 'Update automatically after system updates',
    interval: 'Update interval, seconds',
    manual: 'No updates',
  },
  placeholder: {
    select: 'Select a value',
    renderType: 'Select a render type',
    columnToSort: 'Select a field to sort by',
    value: 'Select a value',
    fieldValue: 'Field value',
    defaultObject: 'Select a default object',
    objectValue: 'Select an object value',
    displayField: 'Displayed Field',
    targetPathArray: 'Target field',
    fieldType: 'Field Type',
    field: 'Field',
    objectFormCode: 'Select an object form internal id',
    bindType: 'Select a bind type',
    valueType: 'Select a value type',
    actionType: 'Select a value action',
    event: 'Select an event',
    selectType: 'Select a type',
    selectTypeFirst: 'Select a type first',
    selectObject: 'Select an object',
    selectCommandType: 'Select type',
    selectCommandCode: 'Select a Command Code',
    selectSourceCommand: 'Select a Source Command',
    selectSourceType: 'Select a Source Type',
    selectLCs: 'Select list controls',
    columnsIds: 'Select columns',
    direction: 'Select a direction',
    category: 'Select a category',
    title: 'Field title',
    placeholder: 'Add name',
    internalId: 'Internal id',
    order: 'Field order',
    selectUpdate: 'Select Update Mode',
    objectsField: 'Object',
    params: 'Json params',
    refPath: 'Data Reading Path',
    dropDownList: 'Select a dropdown list',
    dropDownWindow: 'Select a dropdown window',
    DEFAULT: 'Select a view',
    GANTT_CHART: 'Select a Gantt Chart',
    MENU: 'No options',
    variable: 'Variable',
    selectCommand: 'Select a command',
    styleSettings: 'Style settings',
    javascript: 'Enter JS',
    preFillSourceObject: 'Select a source object',
    comment: 'Comment',
    jsonFilterParams: 'JSON Filter Params',
  },
  label: {
    author: 'Author',
    newValue: 'New Value',
    oldValue: 'Old Value',
    generalFilter: 'General Filter',
    value: 'Value',
    fieldValue: 'Field value',
    fields: 'Fields',
    update: 'Update',
    styleSettings: 'Style settings',
    valueType: 'Value Type',
    displayField: 'Displayed Field',
    targetPathArray: 'Target field',
    dateRange: 'Date Range',
    fieldType: 'Field Type',
    field: 'Field',
    bindType: 'Binding',
    title: 'Title',
    placeholder: 'Placeholder',
    placeholderCheckbox: 'Default',
    internalId: 'Internal Id',
    order: 'Order',
    defaultObject: 'Default object',
    objectValue: 'Object Value',
    objectFormCode: 'Additional form',
    objectsField: 'Group of objects',
    titleHidden: 'Hide',
    userRequired: 'Mandatory',
    editField: 'Edit',
    objectTitle: 'Object',
    commandTitleWithIndex: 'Command №{{number}}',
    commandTitle: 'Command',
    commandType: 'Type',
    commandCode: 'Command Code',
    commandParameters: 'Parameters',
    commandBody: 'Body',
    sourceCommand: 'Source Command',
    sourceType: 'Source Type',
    addCommand: 'Add Command',
    integrationTitle: 'Integration',
    json: 'JSON',
    jsonFilterParams: 'Filter Params',
    params: 'Params',
    dropDownList: 'Dropdown list',
    dropDownWindow: 'Dropdown window',
    asCheckbox: 'As checkbox',
    asDuration: 'As duration',
    durationUnit: 'Duration unit',
    milliseconds: 'Milliseconds',
    seconds: 'Seconds',
    minutes: 'Minutes',
    hours: 'Hours',
    days: 'Days',
    weeks: 'Weeks',
    months: 'Months',
    years: 'Years',
    preFillSourceObject: 'Prefill source object',
    preFillFilterField: 'Prefill filter field',
    preFillType: 'Prefill Type',
    preFillValue: 'Prefill Value',
    multiline: 'Multiline',
    code: 'Code',
  },
  error: {
    valueJS: 'Invalid syntax',
    valueJSON: 'Invalid JSON',
    common: 'Error',
    dynamicFormsExceeded: 'You cannot open more than {{count}} dynamic windows',
    noSearchAssistantInContext: 'No Search Assistant added to this Context',
    noDefaultViewInContext: 'No Default View added to this Search Assistant in this Context',
    allObjectValues: 'All object values are already used',
    mappedCheckboxInvalidValue: 'Value {{outerValue}} is invalid',
    duplicatedSystemName: 'Duplicated System Name',
    configLoadError: 'An error occurred while loading the configuration',
    ganttParametersForm: {
      rowHeightMinMax: 'Should be greater than or equal to 20 and less than or equal to 100',
      segmentHeightMinMax: 'Should be greater than or equal to 20 and less than or equal to 80',
      backlogHeightMin: 'Should be greater than or equal to 100 and less than or equal to 500',
      yAxisWidthMin: 'Should be greater than or equal to 50 and less than or equal to 500',
      realtimeLineWidth:
        'Should be greater than or equal to 1 and less than or equal to 5, step: 0.5',
      rowExpansionHeightMin: 'Should be greater than or equal to 100 and less than or equal to 400',
      boxVerticalGuideLinesWidthMin:
        'Should be greater than or equal to 1 and less than or equal to 5',
      cursorVerticalGuideLineWidthMin:
        'Should be greater than or equal to 1 and less than or equal to 5',
      bordersInnerWidthMin: 'Should be greater than or equal to 1 and less than or equal to 5',
      bordersOuterWidthMin: 'Should be greater than or equal to 1 and less than or equal to 5',
      linesTopWidthMin: 'Should be greater than or equal to 1 and less than or equal to 5',
      linesBottomWidthMin: 'Should be greater than or equal to 1 and less than or equal to 5',
      backgroundGridAppearanceWidthMin:
        'Should be greater than or equal to 1 and less than or equal to 3',
      boxVerticalGuideLinesTypeIncorrect:
        'Incorrect type of guide lines, should match to css property of border-style',
      cursorVerticalGuideLinesTypeIncorrect:
        'Incorrect type of guide lines, should match to css property of border-style',
      activeSegmentMarginMin: 'Should be greater than or equal to 1 and less than or equal to 50',
    },
    functionReturn: `Must contain 'return'`,
    variable: `There is no variable {{variable}}`,
    alreadyUsed: '{{name}} is already used!',
    functionReturnValueType: {
      arrayOfObjects: 'Returned value must be array of objects',
      string: 'Returned value must be string',
      boolean: 'Returned value must be boolean',
    },
    notValidReturnedType: 'Not valid returned type',
    notValidKeyInObject: 'Not valid key in object: {{key}}',
    ganttConfiguration: {
      minColumnsError: 'At least one column is required',
      minSegmentsError: 'At least one segment is required',
      minFieldsError: 'At least one field is required',
      minBarsError: 'At least one bar is required',
      defaultSortFillBothError: 'Both field must be filled',
      segmentDatesError:
        'You have to select at least 2 date fields: Date Start, Date End or Duration',
    },
    required: 'Required',
    notValidSymbolsTitleInput:
      'Only numbers, letters, spaces, dashes, underscores, brackets are available',
    onlyWhitespacesTitleInput: 'Title cannot consist of spaces',
    requiredFieldsMissing: 'Mandatory fields are missing: {{fields}}',
    duplicateViewTitle: '{{title}} is already used',
    duplicateFormTitle: '{{title}} is already used',
    duplicateSearchAssistantTitle: '{{title}} is already used',
  },
  tooltip: {
    openConfigInNewTabBrowser: 'Open In Configurator',
    useUserRestrictions: 'Save user restrictions as default',
    getFormCode: 'Copy Internal ID to the Clipboard',
  },
  configuredView: {
    add: 'Add',
    create: 'Create',
    edit: 'Edit',
    select: 'Select',
    filters: {
      default: 'Filter Orders',
    },
  },
  configControlPanels: {
    add: 'Add Control Panel',
  },
  configWindow: {
    add: 'Add Window',
  },
  configViews: {
    all: 'all',
    groups: 'Groups',
    views: 'views',
    forms: 'forms',
    notAssigned: 'Not assigned',
    add: {
      views: 'Add view',
      forms: 'Add form',
    },
    searchBtn: 'Search',
    searchPlaceholder: {
      views: 'Search schema...',
      forms: 'Search orders...',
    },
    allTab: {
      objectFilter: 'Object',
      search: 'Search',
      searchBoolean: 'Select (Boolean)',
    },
  },
  navigation: 'Navigation',
  pageTitle: {
    timeLineGrid: 'TimeLine Grid',
    timeLines: 'TimeLines',
    barChart: 'Bar Chart',
    styleSettings: 'Style Settings',
    contexts: 'Contexts',
    controlPanels: 'Control Panels',
    windows: 'Windows',
    contextMenu: 'Context Menu',
    models: 'Models',
    modelsControl: 'UI Models Control',
    diagrams: 'Diagrams',
    maps: 'Maps',
    printForms: 'Print forms',
    dictionary: 'Dictionary Values',
    settings: 'Settings',
    menuSetting: 'Menu',
    viewsList: 'Views List',
    ganttModels: 'Gantt Models',
    ganttModelsControl: 'UI Gantt Models Control',
    variables: 'Variable Values',
    displayRules: 'Display Rules',
    displayRulesControl: 'UI Display Rules Models Control',
    tooltips: 'Tooltips',
    searchAssistants: 'Search Assistants',
  },
  configGantt: {
    add: 'Add Gantt',
    ganttList: {
      id: 'ID',
      title: 'Title',
      resourceObjectCode: 'Axis Y Object',
      timelineObjectCode: 'Axis X Object',
    },
  },
  tooltips: {
    title: {
      create: 'Create Tooltip',
      edit: 'Edit Tooltip',
      editJson: 'Edit JSON',
      editJs: 'Edit JS',
      example: 'Tooltip example in JSON',
    },
    button: {
      addTooltip: 'Add tooltip',
      editJson: 'Edit',
      addTooltipPoint: 'Add point',
      addTooltipVariable: 'Add variable',
    },
    placeholder: {
      search: 'Search',
    },
    allTooltipsTable: {
      id: 'ID',
      internalId: 'Internal ID',
      title: 'Title',
      objectName: 'Object',
      width: {
        label: 'Width',
        placeholder: 'Width (default 200)',
      },
    },
    tooltipPointsTable: {
      title: 'Title',
      binding: 'Binding',
      value: 'Value',
      valueType: 'Value Type',
    },
    tooltipPointModal: {
      titleModal: 'New/Edit Tooltip Point',
      title: {
        label: 'Title',
        placeholder: 'Title',
      },
      binding: {
        label: 'Binding',
        placeholder: 'Select a Bind Type',
      },
      value: {
        label: 'Value',
        placeholder: 'Value',
        placeholderSelect: 'Select a Value',
      },
      background: {
        label: 'Background',
        placeholder: 'Background',
      },
      conditionsHidden: {
        label: 'Hidden When',
        placeholder: 'Hidden When',
      },
      valueType: {
        label: 'Value Type',
        placeholder: 'Value Type',
      },
      formatDate: {
        placeholder: 'Format date',
        label: 'Format date',
      },
    },
    tabs: {
      tooltipPoints: 'Tooltip Points',
      config: 'Config',
      variables: 'Dynamic Variables',
      actions: 'Actions',
      staticVariables: 'Static Variables',
    },
    errors: {
      widthMaxValue: 'Should be greater than 0 and less than or equal to 1000',
    },
  },
  controlPanelCreate: {
    title: 'New/Edit Control Panel',
    form: {
      code: {
        label: 'Code',
        placeholder: 'Code',
      },
      title: {
        label: 'Control Panel Title',
        placeholder: 'Control Panel Title',
      },
      lineTitle: {
        label: 'Line Title',
        placeholder: 'Line Title',
      },
      addLineButton: 'Add line',
      removeLineButton: 'Delete line',
      cancelButton: 'Cancel',
      saveButton: 'Save',
      tabs: {
        buttons: 'Buttons',
        icons: 'Icons',
      },
      addItem: {
        pointType: {
          placeholder: 'Select Menu Point Type',
        },
        name: {
          placeholder: 'Name item',
        },
        entityType: {
          placeholder: 'Select Object Type',
        },
        entity: {
          placeholder: 'Select Object',
        },
        showTitle: 'Show Title',
        background: 'Background',
      },
    },
  },
  window: {
    title: {
      edit: 'Edit Window',
      create: 'Create Window',
      copy: 'Copying window',
    },
    form: {
      internalId: {
        label: 'Internal ID',
        placeholder: 'Internal ID',
      },
      windowTitle: {
        label: 'Window Title',
        placeholder: 'Window Title',
      },
      filterSection: {
        label: 'Filter for',
      },
      filter: {
        label: 'Filter',
      },
    },
    tabs: {
      sections: 'Sections',
      variables: 'Variables',
      config: 'Config',
    },
    buttons: {
      cancel: 'Cancel',
      save: 'Save',
      addSection: 'Add Section',
      addEvent: 'Add Event',
      addTab: 'Add Tab',
      addAction: 'Add Action',
    },
    section: {
      label: 'Section',
      placeholder: 'Section Title',
    },
    tab: {
      title: 'Tab',
      label: 'Tab Title',
      placeholder: 'Tab Title',
      object: {
        label: 'Object',
      },
      entityType: {
        label: 'Entity Type',
      },
      entity: {
        label: 'Entity',
      },
      conditions: {
        label: 'Conditions',
        placeholder: 'Conditions',
      },
    },
    action: {
      label: 'Action',
      placeholder: 'Action Title',
    },
    event: {
      label: 'Event',
      postVariable: {
        label: 'Post Variable',
      },
      valueType: {
        label: 'Value Type',
      },
      value: {
        label: 'Value',
        placeholder: 'Value',
        javascript: {
          placeholder: 'Javascript',
        },
      },
    },
    errors: {
      alreadyUsed: 'is already used!',
    },
  },
  ganttCreate: {
    editModel: 'Edit Gantt',
    newModel: 'New Gantt',
    refEdit: 'Edit',
    refPick: 'Pick',
    timelinesAxis: 'Axis X',
    resourceAxis: 'Axis Y',
    objectLinks: 'Link',
    resourceField: 'Resource Field',
    timelinesObjectTooltips: 'Tooltip',
    timelinesObjectTitles: 'Title',
    modalPathPickerObjectsColumn: 'Objects',
    modalPathPickerFieldsColumn: 'Fields',
    hasHeader: 'Header',
    hasFooter: 'Footer',
    hasBacklog: 'Backlog',
    invalidFields: 'Invalid Fields: ',
    validationErrors: 'Validation Errors',
    returnToGanttBtn: 'Return to Gantt',
    footerConfigInfo: 'Config: {{title}} (internal id: {{code}})',
    footerConfigNew: 'Config: New',
    generalForm: {
      stepFieldErrors: {
        code: 'Code',
        title: 'Title',
      },
      timeVisualizationSection: 'Time visualization',
      step: 'General',
      tabs: {
        general: 'General',
        axisX: 'Axis X',
        axisY: 'Axis Y',
      },
      labels: {
        rowHeight: 'Row Height',
        hasBacklog: 'Show',
        backlogHeight: 'Height',
        yAxisWidth: 'Width',
        xAxisWidth: 'X Axis Width',
        noRealTime: 'No Real Time',
        hasRealtimeLine: 'Realtime Line',
        realtimeLineWidth: 'Width',
        realtimeLineColor: 'Color',
        pastBackgroundColor: 'Past Background',
        futureBackgroundColor: 'Future Background',
        unitInterval: 'Unit Interval',
        defaultScale: 'Default Scale',
        hasToolbar: 'Toolbar',
        planningEnabled: 'Show planning',
        planningMode: 'Select mode',
        planningViewAllTasks: 'Show tasks across the whole row',
        planningViewByGroups: 'Show tasks within flight groups',
        isTimeWindow: 'Time Window',
        extraVirtualizationCells: 'Extra Virtualization Cells',
        extraVirtualizationRows: 'Extra Virtualization Rows',
        sortable: 'Sortable',
        rowExpansion: 'Expansible',
        rowsExpansionAtStart: 'Rows expansion at start',
        resizableY: 'Resizable',
        yAxis: 'Y Axis',
        backlog: 'Backlog',
        backgroundGridAppearance: 'Background Grid Appearance',
        isResizableBacklog: 'Resizable',
      },
      placeholders: {
        rowHeight: 'Enter Row Height',
        backlogHeight: 'Enter Backlog Height',
        yAxisWidth: 'Enter Y Axis Width',
        xAxisWidth: 'Enter X Axis Width',
        realtimeLineWidth: 'Enter Realtime Line Width',
        unitInterval: 'Enter Unit Interval',
        defaultScale: 'Enter Default Scale (1–16)',
        extraVirtualizationCells: 'Extra Virtualization Cells',
        extraVirtualizationRows: 'Extra Virtualization Rows',
      },
      params: 'Parameters',
      rowExpansion: 'Row Expansion',
    },
    timelineForm: {
      order: 'Order',
      step: 'Axis X',
      segments: 'segments',
      actions: 'actions',
      dateTimeEnd: 'Date End',
      dateTimeStart: 'Date Start',
      segmentType: 'Type',
      addSegment: 'Add segment',
      key: 'Axis X Key',
      segmentHeight: 'Height',
      background: 'Background',
      systemName: 'System Name',
      additionalFieldsForm: {
        noFieldItems: 'There are no fields',
        tabName: 'Variables',
        variableHeader: 'Variable',
        pathHeader: 'Path',
        availableVariables: 'Available variables',
        copyAlert: 'Copied to clipboard',
        comment: 'Comment',
      },
      hasCorners: 'Corners',
      parameters: 'Parameters',
      generalTitle: 'Title',
      generalTooltip: 'Tooltip',
      duration: 'Duration',
      maxDuration: 'Maximum duration',
      title: 'Title',
      titles: 'Titles',
      segmentDialogCreate: 'Create',
      segmentDialogEdit: 'Edit',
      titleBindingType: 'Title Binding',
      leftTopTitle: 'Left Top Title',
      topTitle: 'Top Title',
      rightTopTitle: 'Right Top Title',
      rightBottomTitle: 'Right Bottom Title',
      bottomTitle: 'Bottom Title',
      leftBottomTitle: 'Left Bottom Title',
      leftTopIcon: 'Left Top Icon',
      topIcon: 'Top Icon',
      rightTopIcon: 'Right Top Icon',
      leftIcon: 'Left Icon',
      centerIcon: 'Center Icon',
      rightIcon: 'Right Icon',
      rightBottomIcon: 'Right Bottom Icon',
      bottomIcon: 'Bottom Icon',
      leftBottomIcon: 'Left Bottom Icon',
      sortBindingType: 'Sort Binding',
      sort: 'Default Sort Data',
      filter: 'Default Filter Data',
      segmentAxisXKey: 'Axis X: {{label}} ({{id}})',
      segmentAxisYKey: 'Axis Y: {{label}} ({{id}})',
      barName: `Bar {{index}} | {{name}} `,
      addBar: 'Add Bar',
      hint: {
        titleScriptHint:
          'Enter a function body that returns a string. Available input parameters: srcObj, restData, metaData or use array "arguments"',
        tooltipScriptHint:
          'Enter a function body that returns a string. Available input parameters: srcObj, restData, metaData or use array "arguments"',
        sortScriptHint: `Expected the function that returns the sorting criterion`,
        sortTextHint: `Expected format: [ { "field":"name","order":"asc" } ]`,
        backgroundColorScriptHint: `Enter a function body that returns a string that matches the color code. Available input parameters: srcObj, restData, metaData or use array "arguments"`,
        backgroundColorStaticHint: `Enter a string that matches the color code.`,
        cornersScriptHint: `Enter a function body that returns a string. Available input parameters: srcObj, restData, metaData or use array "arguments"`,
        filterStaticHint: `Enter a format string [field] [predicate] [value], for example, name == Cancel`,
        contextMenuJsonHint:
          '[{ name, isHeader, isDivider, command, commands: [{type, name}], additionalData, items: [child items of the same format] },...]',
        defaultHint: 'Uses default value',
        segmentHeightHint: 'Enter value as a percentage of the row height (20%-80%)',
      },
      placeholder: {
        titleJS: `return 'string'`,
        tooltipJS: 'return [...]',
        activeSegment: {
          opacity: 'Enter opacity (0–1)',
        },
      },
      bindTypeForm: 'Form',
      bindTypeTooltip: 'Tooltip',
      bindTypeContextMenu: 'Context Menu',
      setDefault: 'Set Default',
      command: 'Command',
      segmentLinksHelper: 'Both fields must be cast to one object/field.',
      segmentLinksError: '',
      segmentLinksErrorOneLink:
        'You need to select a similar object/field {{value}} in another field.',
      segmentLinksErrorLinksNotCorrect:
        'Both fields must be cast to one object/field. Y - {{valueY}}, X - {{valueX}} are expected to be the same',
      segmentLinksCorrect: 'Both fields are cast to one object/field',
      stepFieldErrors: {
        key: 'Axis X Key',
        data: 'Axis X Object',
        commands: 'Commands',
        sections: 'Segments',
      },
      barSteps: {
        data: 'Data',
        appearance: 'Appearance',
        preFilter: 'Pre Filter',
      },
      segmentSteps: {
        data: 'Data',
        appearance: 'Appearance',
        edgeLabels: 'Edge Labels',
        edgeIcons: 'Edge Icons',
      },
      innerBorders: {
        blockLabel: 'Inner Border',
        hasInnerBorders: 'Apply settings',
        color: 'Color',
        width: 'Width',
      },
      outerBorders: {
        blockLabel: 'Outer Border',
        hasOuterBorders: 'Apply settings',
        color: 'Color',
        width: 'Width',
      },
      linesTop: {
        blockLabel: 'Top Line',
        hasLinesTop: 'Apply settings',
        color: 'Color',
        width: 'Width',
      },
      linesBottom: {
        blockLabel: 'Bottom Line',
        hasLinesBottom: 'Apply settings',
        color: 'Color',
        width: 'Width',
      },
      activeSegment: {
        blockLabel: 'Active Segment',
        hasActiveSegment: 'Apply settings',
        color: 'Color',
        opacity: 'Opacity',
        verticalMargin: 'Vertical Margin',
        sideMargin: 'Side Margin',
      },
      text: 'Text',
      useTextSettings: 'Use Text Settings',
      textColor: 'Text Color',
      boxVerticalGuideLines: {
        blockLabel: 'Bar Vertical Guidelines',
        hasBoxVerticalGuideLines: 'Apply settings',
        color: 'Color',
        width: 'Width',
        isBoxColor: 'Is Bar Color',
        type: 'Type',
      },
      row: 'Row',
      addTitle: 'Add Title',
    },
    resourceForm: {
      stepFieldErrors: {
        key: 'Axis Y Key',
        data: 'Axis Y Object',
        commands: 'Commands',
        columns: 'Columns',
      },
      step: 'Axis Y',
      addAction: 'Add Action',
      addColumn: 'Add Column',
      key: 'Axis Y Key',
      sortBindingType: 'Sort Binding',
      sort: 'Default Sort Data',
      sortTextHint: `Expected format: [ { "field":"name","order":"asc" } ]`,
      sortScriptHint: `Expected the function that returns the sorting criterion`,
      filter: 'Default Filter Data',
      timeEdgesFilter: 'Default Time Edges Data',
      hint: {
        filterStaticHint: `Enter a format string [field] [predicate] [value], for example, name == Cancel`,
        tooltipScriptHint:
          'Enter a function body that returns an array of objects. Also you can use srcObj, restData, metaData.',
        tooltipJsonHint: 'Enter an array of objects.',
        contextMenuJsonHint:
          '[{ name, isHeader, isDivider, command, commands: [{type, name}], additionalData, items: [child items of the same format] },...]',
        timeEdgesFilter: `[timeEdgesStart] and [timeEdgesEnd] - these are the start and end segments of the time window. \n
                         Example: \n
                         ((startField>=timeEdgesStart;startField<=timeEdgesEnd),(stopField >=timeEdgesStart;stopField<=timeEdgesEnd)),
                         (startField<=timeEdgesStart;stopField>=timeEdgesEnd).`,
      },
      placeholder: {
        tooltipJS: 'return [...]',
      },
      bindTypeForm: 'Form',
      bindTypeTooltip: 'Tooltip',
      bindTypeContextMenu: 'Context Menu',
      setDefault: 'Set Default',
      command: 'Command',
      fields: 'Fields',
      field: 'Field',
      addField: 'Add Field',
      tabs: {
        data: 'Data',
        columns: 'Columns',
        actions: 'Actions',
        variables: 'Variables',
        preFilter: 'Pre Filter',
        timeEdgesFilter: 'Time Edges Filter',
      },
      additionalFieldsForm: {
        noFieldItems: 'There are no fields',
        tabName: 'Variables',
        variableHeader: 'Variable',
        pathHeader: 'Path',
        availableVariables: 'Available variables',
        copyAlert: 'Copied to clipboard',
        comment: 'Comment',
      },
    },
    mainObjectForm: {
      step: 'Main Object',
      sortAxis: 'Axis',
      field: 'Field',
      order: 'Order',
      sortObj: 'Object',
      mainObject: 'Main Object',
      defaultSort: 'Default Sort',
      stepFieldErrors: {
        value: 'Default Sort',
      },
    },
    parametersForm: {
      step: 'Parameters',
      stepFieldErrors: {
        rowHeight: 'Row Height',
        yAxisWidth: 'Y Axis Width',
        backlogHeight: 'Backlog Height',
        axisX: 'X Axis Width',
      },
      labels: {
        toolbarSettings: {
          blockLabel: 'Toolbar Settings',
        },
        planning: {
          blockLabel: 'Planning view',
        },
        realtimeLine: {
          blockLabel: 'Realtime Line',
          hasRealtimeLine: 'Apply settings',
          color: 'Color',
          width: 'Width',
        },
        cursorVerticalGuideLine: {
          blockLabel: 'Cursor Vertical Guideline',
          has: 'Apply settings',
          color: 'Color',
          width: 'Width',
          type: 'Type',
        },
        backgroundGridAppearance: {
          primaryLine: 'Primary Line',
          secondaryLine: 'Secondary Line',
          horizontalLine: 'Horizontal Line',
          type: 'Type',
          displayValue: 'Apply settings',
          color: 'Color',
          width: 'Width',
          spacing: 'Spacing',
          opacity: 'Opacity',
        },
      },
      placeholders: {
        backgroundGridAppearance: {
          type: 'Enter type',
          displayValue: 'Display element',
          color: 'Enter color',
          width: 'Enter width (max: 3)',
          spacing: 'Enter spacing',
          opacity: 'Enter opacity  (max: 1)',
        },
      },
      boxVisualizationSection: 'Bar visualization',
    },
    common: {
      remove: 'REMOVE',
      add: 'ADD',
      apply: 'Apply',
      removeAll: 'Remove All',
      addVariable: 'Add Variable',
      noItems: 'No Items',
      addItem: 'ADD {{item}}',
      systemVariable: 'System variable derived from pre-filter. Read-only.',
      systemVariableCommentFilter: 'Variable from Axis {{axis}} pre-filter',
      systemVariableCommentTimeEdges: 'Variable from Axis {{axis}} time edges filter',
    },
    columnForm: {
      code: 'System Name',
      title: 'Title',
      bindType: 'Binding',
      value: 'Value',
      valueType: 'Value Type',
      pinnedColumn: 'Pinned Column',
      columnInputs: {
        code: {
          placeholder: 'Column system name',
          label: 'System Name',
        },
        binding: {
          label: 'Binding',
          placeholder: 'Select a Bind Type',
        },
        field: {
          placeholder: 'Column title',
          label: 'Field',
        },
        fieldType: {
          placeholder: 'Field type',
          label: 'Field Type',
        },
        formatDate: {
          placeholder: 'format date',
          label: 'Format date',
        },
        pinnedColumn: {
          label: 'Pinned Column',
        },
        pinning: {
          label: 'Pinning',
        },
        useParameters: {
          label: 'Use Parameters',
        },
      },
    },
    actionForm: {
      code: 'System Name',
      title: 'Title',
      eventCode: 'Event Code',
      actionCode: 'Action',
      value: 'Value',
      valueType: 'Value Type',
      columnTarget: 'Column Target',
      segmentTarget: 'Segment Target',
      actionInputs: {
        code: {
          placeholder: 'Action system name',
          label: 'System Name',
        },
        actionCode: {
          placeholder: '',
          label: 'Action Type',
        },
        eventCode: {
          placeholder: '',
          label: 'Event Type',
        },
        column: {
          placeholder: 'Column',
          label: 'Column',
        },
        title: {
          placeholder: 'Action title',
          label: 'Title',
        },
        target: {
          placeholder: 'Select a segments',
          label: 'Segment',
        },
      },
    },
    unitIntervalOptions: {
      minute: 'Minute',
      quarter: '15 Minutes',
      half: '30 Minutes',
      hour: 'Hour',
      day: 'Day',
      week: 'Week',
      month: 'Month',
      year: 'Year',
    },
    configExamples: {
      blockTitle: 'Configuration examples:',
      contextHeaderMenuY: 'Context header menu for Y with Sort',
      contextMenuWithCommand: 'Context menu with Command',
      simpleTooltip: 'Simple tooltip',
      groupTooltip: 'Group tooltip',
    },
    availableKeysVars: {
      title: 'System Keys & Variables',
      subtitle: 'Click to copy',
    },
    preFilterCorrect: `Pre-filter for {{axis}} {{object}} matches to the main object {{mainObject}}`,
    preFilterIncorrect: `Pre-filter for {{axis}} {{object}} does not match to the main object {{mainObject}}`,
    filterVariablesInfo: 'Some variables were automatically derived from pre-filter fields.',
    systemVariableChecking: 'Checking characteristics...',
    systemVariableResolved: `Characteristic "{{field}}" found in {{objectCode}}`,
    systemVariableUnresolved: `Characteristic "{{field}}" not found in object`,
    systemVariableUnresolvedIn: `Characteristic "{{field}}" not found in {{objectCode}}`,
    fieldsSelectedInContext: 'Already selected in this context',
    fieldInvolvedInConfiguration: 'Already involved in configuration',
    ganttPreview: {
      noDataForPreview: 'Cant find data for preview',
      notValidConfig: 'Config is not valid',
    },
  },
  tableWithFilters: {
    title: 'All',
  },
  dictionary: {
    searchPlaceholder: 'Search orders...',
  },
  viewsExplore: {
    searchPlaceholder: 'Search orders...',
    filters: {
      name: 'Models',
      defaultValue: 'All',
    },
  },
  formCreate: {
    titleJsValue: {
      label: 'Value',
      placeholder: 'Title value',
    },
    isJsTitle: {
      label: 'JS',
    },
    contextMenu: {
      placeholder: 'Select a Context Menu',
      label: 'Context Menu',
    },
  },
  viewsCreate: {
    general: 'General',
    datasource: 'Datasource',
    editable: {
      label: 'Editable',
    },
    multiselection: {
      label: 'Multiselection',
    },
    editModel: {
      views: 'Edit View',
      forms: 'Edit Form',
    },
    newModel: {
      views: 'New View',
      forms: 'New Form',
      id: {
        placeholder: 'Model id',
        label: 'Id',
      },
      code: {
        placeholder: 'Internal id',
        label: 'Internal Id',
      },
      title: {
        placeholder: 'Title',
        label: 'Title',
      },
      preFilter: {
        placeholder: 'Pre-filter',
        label: 'Pre-filter',
      },
      bindRow: {
        label: 'Bind Row to Object',
      },
      defaultSorting: {
        label: 'Use Default Sorting',
      },
    },
    parameters: {
      title: 'Parameters',
    },
    forms: {
      name: 'Fields',
      actions: 'Actions',
      listener: 'Listener',
      btnText: 'Add field',
      config: 'Config',
      variables: 'Variables',
    },
    views: {
      name: 'Columns',
      btnText: 'Add column',
    },
    actions: {
      name: 'Actions',
      btnText: 'Add action',
    },
  },
  profile: {
    personalInfoTitle: 'Personal Information',
    roles: {
      globalTitle: 'Global Access',
      resourceTitle: 'Resource Access',
    },
    save: 'Save',
  },
  modal: {
    applyBtnText: 'Apply',
    saveBtnText: 'Save',
    closeBtnText: 'Close',
    cancelBtnText: 'Cancel',
    createAll: {
      title: 'Creating',
      text: 'Are you sure you want to create all {{entityField}}s?',
      actionButton: 'Create',
    },
    createMandatory: {
      title: 'Creating',
      text: 'Are you sure you want to create all mandatory {{entityField}}s?',
      actionButton: 'Create',
    },
    useUserRestrictions: {
      title: 'Creating',
      text: 'Are you sure you want to save user restrictions as default?',
    },
    edit: {
      title: 'Edit',
    },
    cancelMenuChanges: {
      title: 'Canceling',
      text: 'Are you sure you want to canсel?',
    },
    delete: {
      title: 'Removing',
      warning: 'Are you sure you want to delete?',
      btn: 'Delete',
    },
    changeObjectAxisY: {
      title: 'confirm deletion',
      warning:
        'Selected object involved in settings of columns and bar links. If submit all columns and bars will be removed',
      btn: 'Delete',
    },
    changeObjectAxisX: {
      title: 'Confirm deletion',
      warning:
        'Selected object involved in settings of segments. If submit all segments will be removed',
      btn: 'Delete',
    },
    deleteBar: {
      title: 'Confirm deletion',
      warning: 'Are you sure you want to delete Bar {{index}}',
      btn: 'Delete',
    },
    clearFieldArray: {
      title: 'Confirm deletion',
      warning: 'Are you sure you want to delete all fields?',
      btn: 'Delete',
    },
    deleteVariable: {
      title: 'Confirm deletion',
      warning:
        'Variable may be involved in settings. Are you sure you want to variable {{variable}}?',
      btn: 'Delete',
    },
    success: {
      title: 'INFORMATION',
    },
    error: {
      title: 'ERROR',
    },
    warning: {
      title: 'WARNING',
    },
    info: {
      title: 'INFORMATION',
    },
    continue: {
      btn: 'Continue',
    },
  },
  addDialog: {
    create: 'New',
    edit: 'Edit',
    parameters: 'Parameters',
    columnFields: 'Column Fields',
  },
  viewOrFormCreate: {
    saveBtnText: 'Save',
    cancelBtnText: 'Cancel',
    saveConfigurationText: 'Save configuration',
    cancelConfigurationText: 'Cancel',
    nextStepText: 'Next',
    prevStepText: 'Previous',
    resetText: 'Reset',
    stepViewText: 'View Configuration',
    stepTabsText: 'Filter Tabs Configuration',
    stepSave: 'Save view',
    filtersStepTitle: 'Choose Tabs',
    sortingsStepTitle: 'Choose Sortings for the Table',
    tabsTitle: 'Created Filter Tabs',
    sortingsTableTitle: 'Created Sortings',
    tableConfigTitle: 'Table Configuration',
    mainColumnsTitle: 'Main Columns',
    actionColumnsTitle: 'Action Columns',
    tabsForm: {
      title: {
        placeholder: 'Tab title',
        label: 'Title',
      },
      filterValue: {
        placeholder: 'Filter value',
        label: 'Filter value',
      },
      filterColumns: {
        label: 'Filter Columns',
        placeholder: 'Select columns',
      },
      sortingDirection: {
        placeholder: 'Select a direction',
        label: 'Sorting Direction',
      },
      sortingColumns: {
        label: 'Sorting Column',
        placeholder: 'Select column',
      },
      addBtnText: 'Add',
      skipBtnText: 'Skip this step',
    },
    sortingsForm: {
      title: {
        label: 'Sorting Title',
        placeholder: 'Sorting Title',
      },
      code: {
        label: 'Sorting Internal Id',
        placeholder: 'Sorting internal id',
      },
      columns: {
        label: 'Sorting to Apply',
      },
      direction: {
        label: 'Sorting Direction',
      },
      defaultSorting: {
        label: 'Default Sorting',
      },
    },
  },
  configContextMenu: {
    add: 'Add Context Menu',
    hasObjects: 'You are going to delete the context menu associated with the objects:',
  },
  contextMenuCreate: {
    title: 'New/Edit Context Menu',
    timelineOptions: 'Timeline Options',
    tabs: {
      menuPoints: 'Menu Points',
      dynamicVariables: 'Dynamic Variables',
      staticVariables: 'Static Variables',
    },
    addMenuPoint: 'Add menu point',
    addMenuPointModal: {
      titleModal: 'New/Edit Context Menu Point',
      header: {
        label: 'Header',
        placeholder: 'Header',
      },
      divider: {
        label: 'Divider',
        placeholder: 'Divider',
      },
      group: {
        label: 'Group',
        placeholder: 'Group',
      },
      title: {
        label: 'Title',
        placeholder: 'Title',
        errors: {
          used: '{{name}} is already used',
        },
      },
      jsTitle: {
        label: 'JS',
        placeholder: 'JS',
      },
      titleJsValue: {
        label: 'Title Value',
        placeholder: 'Title Value',
      },
      menuPointType: {
        label: 'Menu Point Type',
        placeholder: 'Select a Menu Point Type',
      },
      objectType: {
        label: 'Object Type',
        placeholder: 'Select an Object Type',
      },
      value: {
        label: 'Value',
        placeholder: 'Select a Value',
      },
      parameters: {
        label: 'Parameters',
        placeholder: 'Parameters',
      },
      body: {
        label: 'Body',
        placeholder: 'Body',
      },
      conditionsDisabled: {
        label: 'Disabled When',
        placeholder: 'Disabled When',
      },
      conditionsHidden: {
        label: 'Hidden When',
        placeholder: 'Hidden When',
      },
      showOnSelection: {
        label: 'Show on selection',
      },
    },
    addVariable: 'Add variable',
    form: {
      title: {
        placeholder: 'Title',
        label: 'Title',
      },
      object: {
        placeholder: 'Object',
        label: 'Object',
      },
      applicableTo: {
        placeholder: 'Applicable To',
        label: 'Applicable To',
      },
      saveButton: 'Save',
      cancelButton: 'Cancel',
    },
  },
  menuSetting: {
    formForAdding: {
      item: {
        label: 'Add Menu Item or Group',
        placeholder: 'Name item or group',
        addItem: 'Add Item or Group',
      },
    },
    isEmpty: 'The Menu is Empty',
  },
  notifications: {
    success: 'Success',
    error: 'Something went wrong',
    leave: 'You have unsaved changes. Are you sure?',
    rowIsFull: 'There is no free space in this line',
    cannotFitView: 'You can add "list" to a new line',
    columnHidding:
      'Sorting column not found. Check the visibility setting of the column "{{columnName}}"',
    emptyFilter:
      'No values were found for the applied filter. Check the "Filter value" parameters in the tab "{{tabName}}"',
    changeContext:
      'You are going to change the Context. All open windows will be closed. Are you sure?',
    repeatedRequest: 'Previous request is still in progress',
    createCommandMissing: 'Create command is not configured for this form',
    updateCommandMissing: 'Update command is not configured for this form',
  },
  form: {
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    empty: 'No rows',
    noForm: 'Form not found',
    deleteRow: 'Object not found',
    show: 'Show',
    hide: 'Hide',
    fieldObjectRequired: 'This field is required on object level',
    addField: {
      displayFieldMissingEmbeddedObject:
        'The Displayed Field path does not include the object referenced by the {{fieldName}} field. The selected value may not display correctly when editing the form.',
      targetPathArrayMissingEmbeddedObject:
        'The Target field path does not include the object referenced by the {{fieldName}} field. Data may not be saved correctly when you save the form.',
    },
  },
  field: 'Field',
  cell: {
    error: 'Error',
  },
  reactTable: {
    noRows: 'No rows',
  },
  filter: {
    buttonInfo: 'The filter is saved in the "Saved seacrh" section View',
    search: 'Search',
    clean: 'Clean',
    create: 'Search assistant',
    pinned: 'Pinned filters',
    saved: 'Saved search',
    chipsDesc: 'Search filters',
    activatedTimeWindow: 'ACTIVATED TIME WINDOW',
    editTitle: 'Edit the title of a saved search',
    edit: 'Edit',
    save: 'Save',
    delete: 'Delete',
    rules: {
      contain: 'Contain',
      notContain: 'Not contain',
      equal: 'Equal',
      notEqual: 'Not equal',
      startsWith: 'Starts with',
      endsWith: 'Ends with',
      empty: 'Empty',
      notEmpty: 'Not empty',
      more: 'More',
      less: 'Less',
      moreOrEqual: 'More or equal',
      lessOrEqual: 'Less or equal',
    },
    favorites: {
      button: 'Favorites',
      manage: 'Manage ...',
      save: 'Save',
      saveAs: 'Save as ...',
      dialog: {
        title: 'Filters',
        columnName: 'Name',
        columnDefault: 'Default',
        rename: 'Rename',
        delete: 'Delete',
        ok: 'Ok',
        cancel: 'Cancel',
        close: 'Close',
        save: 'Save',
      },
    },
    reset: 'Reset',
  },
  historyTable: {
    title: 'History',
  },
  searchAssistant: {
    title: 'Search Assistant',
    addBtnText: 'Add Search Filter',
    result: 'Results ({{totalElements}})',
    btnPick: 'Pick',
    defaultView: 'Default View',
    searchRule: 'Search rule',
    oneRelative: 'Allowed only one relative value field type',
    affects: 'Affects the order in the {{entity}}',
    alreadyUsedDialog: {
      title: 'Save',
      cancel: 'Cancel',
      replace: 'Replace',
      info: 'The search "{{name}}"  is already saved in the system.',
      question: 'Do you want to replace this search?',
    },
    defaultSetting: {
      title: 'Default Setting',
      button: 'Default Setting',
      objectsLabel: 'OBJECTS',
      autocompleteLabel: 'DEFAULT FILTERS',
    },
    filtration: {
      object: {
        label: 'Object',
        placeholder: 'Select a Object Value',
      },
      view: {
        label: 'Search for',
        placeholder: 'Select a View',
      },
    },
    openEditPageButtonText: 'Open search assistant edit page',
  },
  searchAssistantTable: {
    id: 'ID',
    internalID: 'Internal ID',
    title: 'Title',
    object: 'Object',
    value_params: 'Value Params',
    value: 'Value',
    field_type: 'Field Type',
    objectValue: 'Object Value',
  },
  sidebar: {
    links: {
      styleSettings: 'Style settings',
      contexts: 'Contexts',
      controlPanels: 'Control Panels',
      contextMenu: 'Context Menu',
      ganttChart: 'Gantt-Chart',
      uiConfigs: 'UI configs',
      timeLines: 'TimeLines',
      views: 'Views',
      forms: 'Forms',
      diagrams: 'Diagrams',
      maps: 'Maps',
      listControls: 'List Controls',
      dropdownEntities: 'Dropdown Entities',
      dictionary: 'Dictionary',
      menuSetting: 'Menu Setting',
      search: 'Search Assistant',
      parameters: 'Parameters',
      tooltips: 'Tooltips',
      searchAssistants: 'Search Assistants',
      variables: 'Variables',
      windows: 'Windows',
      displayRules: 'Display Rules',
      profile: {
        settings: 'Settings',
        edit: 'Edit Profile',
        help: 'Help',
      },
    },
  },
  viewColumnsTable: {
    id: 'Internal Id',
    title: 'Title',
    bindType: 'Binding',
    order: 'Order',
    width: 'Width',
    sort: 'Sort',
    show: 'Show',
    value: 'Value',
    valueType: 'Value Type',
    columnToSort: 'Field to Sort and Filter',
    pinnedColumn: 'Pinned Column',
    qsEnabled: 'QS Enabled',
    qsDefault: 'QS Default',
  },
  viewActionsTable: {
    id: 'Internal Id',
    title: 'Title',
    eventCode: 'Event',
    actionCode: 'Action',
    params: 'Params',
    objectFormCode: 'Object Form',
    contextMenu: 'Context Menu',
    tooltip: 'Tooltip',
    targetColumn: 'Target Column',
  },
  entityActionDialog: {
    contextMenu: {
      placeholder: 'Select a Context Menu',
      label: 'Action Value',
    },
    tooltip: {
      placeholder: 'Select a Tooltip',
      label: 'Action Value',
    },
    targetColumn: {
      placeholder: 'Select a Target Column',
      label: 'Target',
    },
  },
  configColumnsTable: {
    id: 'ID',
    code: 'Internal Id',
    title: 'Title',
    objectTitle: 'Object',
  },
  displayRulesColumnsTables: {
    code: 'Internal Id',
    title: 'Title',
    objectTitle: 'Object',
  },
  displayRulesValueColumns: {
    fieldValue: 'Field Value',
    styleSettings: 'Style Settings',
  },
  searchAssistantsColumnsTables: {
    code: 'Internal Id',
    title: 'Title',
    objectTitle: 'Object',
  },
  formColumnsTable: {
    code: 'Internal Id',
    title: 'Title',
    bindType: 'Binding',
    value: 'Value',
    valueType: 'Value Type',
  },
  tabsColumnTable: {
    title: 'Title',
    filterValue: 'Filter Value',
    sortingColumns: 'Sorting Column',
    sortingDirection: 'Sorting Direction',
  },
  sortingsColumnsTable: {
    title: 'Title',
    columns: 'Sorting Value',
    direction: 'Sorting Direction',
  },
  dictionaryTable: {
    id: 'ID',
    code: 'Internal Id',
    title: 'Title',
    categoryTitle: 'Category',
  },
  objectFieldChangesColumnsTable: {
    changeDate: 'Date',
    author: 'Author',
    field: 'Field',
    newValue: 'New Value',
    oldValue: 'Old Value',
  },
  variableTable: {
    internalId: 'Internal Id',
    title: 'Title',
    variableType: 'Variable Type',
    valueType: 'Value Type',
  },
  fieldsConfig: {
    configuration: 'Configuration',
    fields: 'Fields',
    lists: 'Lists',
    elements: 'Elements',
    delete: 'Delete',
    deleteText: 'Are you sure you want to delete this element?',
    deleteBtnText: 'Delete',
    cancelDeleteBtnText: 'Cancel',
    helperText: {
      action: 'Action',
    },
    placeholder: {
      emptyContainer: ' Create a New Tab',
      title: 'Enter a Title',
      text: 'Enter a Text',
      action: 'Select an Action',
      fieldsFilter: 'Enter the Field Title',
    },
    outerParameters: {
      addEditButton: '{{mode}} outer parameters',
      addFilter: 'Add filter',
      dialog: {
        title: '{{type}} outer parameters',
        tabs: {
          filter: 'Filter',
          actions: 'Actions',
          commands: 'Commands',
        },
        labels: {
          title: 'Title',
          code: 'Internal Id',
          filter: 'Filter',
        },
        placeholder: {
          title: 'Title',
          code: 'Internal Id',
          filter: 'Enter a code filter',
        },
      },
    },
  },
  sectionsConfig: {
    configuration: 'Configuration',
    available: 'Available Sections',
  },
  actionInputs: {
    code: {
      placeholder: 'Action internal id',
      label: 'Internal Id',
    },
    title: {
      placeholder: 'Action title',
      label: 'Title',
    },
    jsValue: {
      placeholder: 'Specify the js being executed',
      label: 'Js Value',
    },
    actionCode: {
      placeholder: 'Action type',
      label: 'Action type',
    },
    variable: {
      placeholder: 'Select a variable',
      label: 'Variable',
    },
    draggableElementText: {
      placeholder: '',
      label: 'Draggable text',
    },
    field: {
      placeholder: '',
      label: 'Field',
    },
    eventCode: {
      label: 'Event',
    },
    params: {
      placeholder: 'Json params',
      label: 'Params',
    },
    column: {
      label: 'Column',
      placeholder: 'Target column',
    },
    formObject: {
      label: 'Object',
      placeholder: 'Object for form',
    },
    viewObject: {
      label: 'Object',
      placeholder: 'Object for view',
    },
    view: {
      label: 'View',
      placeholder: 'Select view',
    },
    segment: {
      label: 'Segment',
      placeholder: 'Target segment',
    },
    command: {
      label: 'Command',
      placeholder: 'Command',
    },
    formCommands: {
      label: '{{mode}} Commands',
      placeholder: 'Commands',
    },
  },
  columnInputs: {
    errors: {
      alreadyUsed: 'is already used!',
      notAllowed: 'is not allowed',
    },
    value: {
      fieldPlaceholder: 'Field value',
      label: 'Value',
    },
    code: {
      placeholder: 'Internal id',
      label: 'Internal id',
    },
    title: {
      placeholder: 'Field title',
      label: 'Title',
    },
    bindType: {
      label: 'Binding',
    },
    columnToSort: {
      label: 'Field to Sort and Filter',
    },
    pinning: {
      label: 'Pinning',
    },
    pinnedColumn: {
      label: 'Pinned column',
    },
    useParameters: {
      label: 'Use Parameters',
    },
    editable: {
      label: 'Disable Editing',
    },
    quickSearch: {
      label: 'Quick search',
      disabledColumnRule: `This column is not supported by the rule "{{name}}" or restricted by administrator`,
      checkAllCheckbox: {
        label: 'Check all columns',
        booleanLabel: 'Check all boolean columns',
      },
    },
    wrapRowText: {
      label: 'Wrap Row Text',
    },
    WrapHeaderText: {
      label: 'Wrap Header Text',
    },
    searchAssistant: {
      label: 'Show Search Assistant',
    },
    enumDescription: {
      label: 'Description for enum',
    },
    useDisplayRule: {
      label: 'Use Display Rule',
    },
    displayRule: {
      label: 'Display Rule',
    },
  },
  searchFilterForm: {
    formTitle: {
      new: 'New Filter',
      edit: 'Edit Filter',
    },
    alreadyUsedCode: 'is already used!',
    emptySearch: 'There are no saved searches',
    emptyCriterias: 'No search filters',
    dialog: {
      title: 'Save search filter',
      description: 'Please enter the title of the search filter:',
      label: 'Title',
    },
    timeUnit: {
      placeholder: 'Time Unit',
      label: 'Time Unit',
    },
    min: {
      placeholder: 'Min',
      label: 'Minimum',
      validation: 'Min value must be less than max value',
    },
    max: {
      placeholder: 'Max',
      label: 'Maximum',
      validation: 'Max value must be greater than min value',
    },
    id: {
      placeholder: 'Internal Id',
      label: 'Internal Id',
    },
    title: {
      placeholder: 'Field title',
      label: 'Title',
    },
    object: {
      placeholder: 'Select a object value',
      label: 'Object',
    },
    value: {
      placeholder: 'Select a value',
      label: 'Value',
      addButtonTitle: 'ADD VALUE',
    },
    fieldType: {
      placeholder: 'Select a field type',
      label: 'Field Type',
    },
    formatDate: {
      placeholder: 'Select date format',
      label: 'Format Date',
    },
    timeIncrement: {
      placeholder: 'Time Increment',
      label: 'Time Increment, minutes',
    },
    objectValue: {
      placeholder: 'Select a object value',
      label: 'Object Value',
    },
    pinning: {
      label: 'Pinning',
    },
    groupRelated: {
      label: 'Group related',
    },
    filterByObject: {
      label: 'Filter by Object',
    },
    defaultPlaceholder: {
      label: 'Default',
    },
    placeholderValue: {
      placeholder: 'Add name',
      label: 'Placeholder',
    },
    placeholderStart: {
      placeholder: 'Add name',
      label: 'Placeholder',
    },
    placeholderEnd: {
      placeholder: 'Add name',
      label: 'Placeholder',
    },
  },
  groups: {
    variant: {
      view: {
        element: 'View',
        group: 'Group of views',
        error: {
          alreadyUsed: 'is already used!',
        },
      },
      listControl: {
        element: 'List Control',
        group: 'Group of list controls',
        error: {
          alreadyUsed: 'is already used!',
        },
      },
      forms: {
        element: 'Form',
        group: 'Group of forms',
      },
    },
    placeholder: {
      view: {
        groupName: 'Enter the name of the group',
        select: 'Select a view',
        selectType: 'Select element type',
      },
      listControl: {
        groupName: 'Enter the name of the group',
        select: 'Select a view',
        selectType: 'Select element type',
      },
      forms: {
        groupName: 'Enter the name of the group',
        select: 'Select a form',
        selectType: 'Select element type',
      },
    },
  },
  copying: {
    view: {
      dialogTitle: 'Copying view',
    },
    form: {
      dialogTitle: 'Copying form',
    },
    context: {
      dialogTitle: 'Copying context',
    },
    controlPanel: {
      dialogTitle: 'Copying control panel',
    },
    window: {
      windowsTitle: 'Copying window',
    },
    contextMenu: {
      dialogTitle: 'Copying context menu',
    },
    listControl: {
      dialogTitle: 'Copying list control',
    },
    diagram: {
      dialogTitle: 'Copying diagram',
    },
    timeline: {
      dialogTitle: 'Copying timeline',
    },
    dropdownEntity: {
      dialogTitle: 'Copying dropdown entity',
    },
    map: {
      dialogTitle: 'Copy Map',
    },
    inputs: {
      code: {
        label: 'Internal Id',
        placeholder: 'Internal Id',
      },
      title: {
        label: 'Title',
        placeholder: 'Title',
      },
      objectCode: {
        label: 'Object',
      },
    },
    gantt: {
      label: 'Copying gantt',
      command: {
        success: 'Command {{commandCode}} successfully completed',
        failed: 'Command {{commandCode}} execution failed',
      },
    },
  },
  parameters: {
    resetButton: 'Reset to default',
    resetModal: {
      title: 'Resetting',
      text: 'Are you sure you want to reset?',
      actionBtnText: 'Reset',
    },
    common: {
      title: 'Common Parameters',
      save: 'Save',
      numberOfWindows: 'Number of Windows',
      timeZone: 'Time Zone',
      pagination: 'Pagination',
      appTitle: 'App Title',
    },
    visual: {
      example: 'example',
      save: 'Save',
      edit: 'Edit',
      cancel: 'Cancel',
      title: 'Visual Parameters',
      header: 'Views. Global Header Text Settings',
      background: 'Background',
      border: 'Border',
      columnHeader: 'Header',
      headerHeight: 'Header height in px',
      headerGroupHeight: 'Group height in px',
      columnText: 'Text',
      alignOptions: {
        left: 'Left',
        center: 'Center',
        right: 'Right',
      },
      exampleText: 'Example',
    },
    errors: {
      headerHeightMinAndMax: 'Should be greater than 30 and less than or equal to 150',
    },
  },
  displayRules: {
    button: {
      add: 'Add Display Rule',
      cancel: 'Cancel',
      save: 'Save',
      addRule: 'Add Rule',
    },
    title: {
      create: 'Create Display Rule',
      edit: 'Edit Display Rule',
    },
    titleRule: {
      create: 'Create Rule',
      edit: 'Edit Rule',
    },
    label: {
      internalId: 'Internal_id',
      title: 'Title',
      object: 'Object',
      objectField: 'Object field',
      javascript: 'JS',
      styleSettings: 'Style Settings',
      styleSetting: 'Style setting',
    },
    placeholder: {
      internalId: 'Internal_id',
      title: 'Title',
      object: 'Object',
      objectField: 'Object field',
      javascript: 'JS',
      styleSettings: 'Style Settings',
      styleSetting: 'Style setting',
    },
    errors: {
      alreadyUsed: 'is already used!',
    },
  },
  objectPicker: {
    openForm: 'Open form: {{formTitle}}',
  },
  configEntity: {
    deleteAll: 'Delete all',
    allEntities: {
      createAll: 'Add all columns',
      createAllMandatory: 'Add mandatory columns',
    },
    allForms: {
      createAll: 'Add all fields',
      createAllMandatory: 'Add mandatory fields',
    },
    restrictions: 'Restrictions',
    useUserRestrictions: 'Use user restrictions as default',
    variables: {
      column: {
        internalId: {
          label: 'Internal Id',
        },
        variableTitle: {
          label: 'Variable Title',
        },
        variableType: {
          label: 'Variable Type',
        },
        valueType: {
          label: 'Value Type',
        },
      },
      internalId: {
        label: 'Internal Id',
      },
      variableTitle: {
        label: 'Variable Title',
      },
      variableType: {
        label: 'Variable Type',
      },
      valueType: {
        label: 'Value Type',
      },
      reservedVariable: {
        tooltip: 'This variable value "{{value}}" will be used for system purposes',
      },
      button: {
        addVariable: 'Add Variable',
      },
      error: {
        alreadyUsed: '{{title}} is already used!',
      },
    },
    listControl: {
      tabs: {
        all: 'All',
        groups: 'Groups',
      },
      columns: {
        title: 'Columns',
        addButton: 'Add Column',
      },
      actions: {
        title: 'Actions',
        addButton: 'Add Action',
      },
      order: {
        title: 'Order',
      },
      parameters: {
        title: 'Parameters',
      },
      addButton: 'Add List Control',
      search: 'Search',
      object: 'Object',
      editModel: 'Edit List Control',
      newModel: 'Add List Control',
    },
    dropdownEntity: {
      tabs: {
        all: 'All',
      },
      columns: {
        title: 'Columns',
        addButton: 'Add Column',
      },
      order: {
        title: 'Order',
      },
      parameters: {
        title: 'Parameters',
      },
      addButton: 'Add Dropdown Entity',
      search: 'Search',
      object: 'Object',
      editModel: 'Edit Dropdown Entity',
      newModel: 'Add Dropdown Entity',
    },
    view: {
      tabs: {
        all: 'All',
        groups: 'Groups',
      },
      columns: {
        title: 'Columns',
        addButton: 'Add Column',
      },
      actions: {
        title: 'Actions',
        addButton: 'Add Action',
      },
      order: {
        title: 'Order',
      },
      parameters: {
        title: 'Parameters',
      },
      addButton: 'Add View',
      search: 'Search',
      object: 'Object',
      editModel: 'Edit View',
      newModel: 'Add View',
      resetRestrictions: 'Reset restrictions',
      autosizeColumns: 'Autosize columns',
      fixedByAdmin: 'This column is fixed by the administrator',
    },
    form: {
      actions: {
        title: 'Actions',
        addButton: 'Add Action',
      },
    },
    warning: "Don't forget to add the mandatory fields you need",
  },
  stringEdit: {
    buttons: {
      cancel: 'Cancel',
      save: 'Save',
    },
    title: 'Edit field {{field}}',
  },
  styleSettings: {
    addButton: {
      styleSetting: 'Add Style Setting',
    },
    title: {
      create: 'Add Style Setting',
      edit: 'Edit Style Setting',
      styleSetting: 'Title',
    },
    internalId: {
      label: 'Internal Id',
      placeholder: 'Internal Id',
    },
    saveButton: 'save',
    cancelButton: 'cancel',
  },
  searchAssistants: {
    addButton: {
      searchAssistants: 'Add SA',
    },
    title: {
      create: 'Create Search Assistant',
      edit: 'Edit Search Assistant',
      datasource: 'Data Source',
      copyDialog: 'Copying Search Assistant',
    },
    label: {
      internalId: 'Internal Id',
      title: 'Title',
    },
    error: {
      alreadyUsed: 'is already used!',
    },
    placeholder: {
      internalId: 'Internal Id',
      title: 'Title',
    },
  },
  contexts: {
    addButton: {
      context: 'Add Context',
      view: 'Add View',
      ganttChart: 'Add Gantt Chart',
      controlPanel: 'Add Control Panel',
      variable: 'Add Variable',
    },
    saveButton: 'Save',
    cancelButton: 'Cancel',
    searchButton: 'Search',
    searchPlaceholder: 'Search',
    chooseContext: 'Choose context',
    continue: 'Continue',
    continueWithoutContext: 'Continue without context',
    placeholder: {
      selectContext: 'Select a context',
      emptyContext: 'No contexts',
      search: 'Search',
      selectView: 'Select a view',
      selectGantt: 'Select a gantt',
      selectControlPanel: 'Select a control panel',
      selectVariable: 'Select a variable',
      selectSearchAssistant: 'Select a search assistant',
    },
    title: {
      create: 'New Context',
      edit: 'Edit Context',
      context: 'Context title',
      searchAssistant: 'Search Assistant',
      view: 'View Title',
      ganttChart: 'Gantt Title',
      controlPanel: 'Control Panel Title',
      variable: 'Variable',
    },
    tabs: {
      views: 'Views',
      ganttCharts: 'Gantt Charts',
      controlPanels: 'Control Panels',
      variables: 'Variables',
      searchAssistant: 'Search Assistant',
      workingArea: 'Working Area',
    },
    tableColumns: {
      title: 'Title',
      object: 'Object',
      axisY: 'Axis Y Object',
      axisX: 'Axis X Object',
      variable: 'Variable',
      path: 'Path',
      value: 'Value',
      actions: {
        add: 'Add',
        delete: 'Delete',
        default: 'Default',
      },
    },
    addedViews: 'VIEWS ADDED TO CONTEXT',
    notAddedViews: 'VIEWS NOT ADDED TO CONTEXT',
    addedGanttCharts: 'GANTT CHARTS ADDED TO CONTEXT',
    notAddedGanttCharts: 'GANTT CHARTS NOT ADDED TO CONTEXT',
    defaultBackgroundEntity: 'Default Background Entity',
  },
  variables: {
    addButton: 'Add Variable',
    saveButton: 'Save',
    cancelButton: 'Cancel',
    searchPlaceholder: 'Search',
    title: {
      create: 'New variable',
      edit: 'Edit variable',
    },
    label: {
      internalId: 'Internal Id',
      title: 'Title',
      variableType: 'Variable Type',
      valueType: 'Value Type',
    },
  },
  addIcon: 'Add Icon',
  removeIcon: 'Remove Icon',
  iconPicker: {
    menu: 'ICON PICKER MENU',
    tab: {
      initial: 'INITIAL',
      common: 'COMMON',
      additional: 'ADDITIONAL',
    },
  },
  configByObject: {
    enumPostfix: 'ENUM',
    primaryKeyPostfix: 'PK',
  },
  configuredGantt: {
    incorrectDefFilters: 'Incorrect Default Config Filters',
    incorrectSubscriptionMessage: 'Incorrect Subscription Message',
    infoAfterResize: 'Смещение в начало страницы',
    infoSameSorting: 'Эта сортировка уже применена',
  },
  executeCodeError: 'Ошибка выполенния кода: ',
  alreadyError: '{{value}} is already exist',
  fieldForm: {
    fieldValues: {
      title: 'Field Values',
      value: {
        label: 'Field Value',
        placeholder: 'Field Value',
      },
      text: {
        label: 'Label',
        placeholder: 'Label',
      },
    },
  },
  contextMenu: {
    noOptions: 'No options',
  },
  commandParameters: {
    title: {
      body: 'Body',
      params: 'Parameters',
    },
    inputs: {
      parameter: {
        label: 'Parameter',
        placeholder: 'Select A Parameter',
      },
      type: {
        label: 'Type',
        placeholder: 'Select A Type',
      },
      value: {
        label: 'Value',
        placeholder: 'Select a value',
      },
    },
    buttons: {
      edit: 'EDIT',
      pick: 'PICK',
      goTo: 'Go to',
    },
    table: {
      empty: 'No parameters',
      headers: {
        parameter: 'Parameter',
        type: 'Bind type',
        value: 'Value',
        valueType: 'Value type',
        default: 'Default',
      },
      tooltips: {
        clearRow: 'Clear row',
      },
    },
    validation: {
      requiredSummary: 'Some required parameters are not filled: {{count}}',
    },
    toggle: {
      all: 'Show all',
      configured: 'Show configured',
    },
  },
  timeLines: {
    add: 'Add TimeLine',
  },
  diagrams: {
    add: 'Add diagram',
    internalId: 'Internal Id',
    title: 'Title',
    object1: 'Object 1',
    object2: 'Object 2',
    axisX: 'Axis X',
  },
  diagramsCreateOrEdit: {
    header: 'New/Edit Diagram',
    title: {
      label: 'Title',
      placeholder: 'Title',
    },
    id: {
      label: 'Internal Id',
      placeholder: 'Model Internal Id',
    },
    tabs: {
      columns: 'Columns',
      axisX: 'Axis X',
      view: 'View',
    },
    axisX: {
      axisX: 'AXIS X',
      period: 'Period',
      dateRange: 'Time Interval',
      timeIncrement: 'Time Increment',
      formatDate: 'Date Format',
      title: 'Title',
      from: 'From',
      to: 'To',
      addSeries: 'Add series',
      series: 'Series',
    },
    columns: {
      code: 'Internal Id',
      title: 'Title',
      object: 'Object',
      color: 'Color',
      series: 'Series',
      prefilter: 'Pre-Filter',
      binding: 'Binding',
      fields: 'Fields',
      addColumn: 'Add column',
      operation: 'Operation',
      command: 'Command',
      useJS: 'Use JS on every series',
      useCommandForEverySeries: 'Use command on every series',
    },
    view: {
      object: 'Object',
      view: 'View',
    },
    cancelButton: 'Cancel',
    saveButton: 'Save',
  },
  maps: {
    add: 'Add map',
    internalId: 'Internal Id',
    title: 'Title',
  },
  printForms: {
    add: 'Add',
    internalId: 'Internal Id',
    titleField: 'Title',
    print: 'Print',
    objectCode: 'Object Code',
    commandCode: 'Command Code',
    method: 'HTTP Method',
    paperSize: 'Paper Size',
    orientation: 'Orientation',
    documentTemplate: 'Document Template (HBS)',
    createHeader: 'New Print Form',
    editHeader: 'Edit Print Form',
    generalSection: 'General',
    commandSection: 'Command',
    commandParams: 'Parameters',
    commandBody: 'Body',
    templateSection: 'Document Template',
    save: 'Save',
    cancel: 'Cancel',
    validation: {
      required: 'Required field',
    },
    copy: {
      title: 'Copy Print Form',
      submit: 'Copy',
      idExists: 'This ID already exists',
    },
    orientations: {
      portrait: 'Portrait',
      landscape: 'Landscape',
    },
    templateEditor: {
      editTemplate: 'Edit HTML / Handlebars',
      editMainTemplate: 'Edit document template',
      mainDialogTitle: 'Document template (HTML / Handlebars)',
      handlebarsSubtitle: 'HTML / Handlebars',
      partialsTitle: 'Partials',
      editPartial: 'Edit partial "{{name}}"',
      partialDialogTitle: 'Partial "{{name}}" (HTML / Handlebars)',
    },
    printFormVou: {
      errors: {
        configNotFound: 'Print form config "{{id}}" not found',
        commandRequired: 'A command is required for voucher print',
        noFileBody: 'Voucher print does not support files in the command body',
        needsTabularData:
          'Voucher print requires tabular data; command response mode is not supported',
        noRecords: 'No data to print: the command returned no records',
      },
      snackbar: {
        fallback: 'Could not run voucher print',
      },
    },
  },
  mapCreateOrEdit: {
    header: 'New/Edit Map',
    general: 'General',
    mapSettings: 'Map Settings',
    mapSettingsButton: 'Map Settings',
    mapSettingsDialogTitle: 'Map Settings',
    mapSettingsCenter: 'Center',
    mapSettingsMaxBounds: 'Max Bounds',
    internalId: 'Internal Id',
    internalIdPlaceholder: 'Internal Id',
    title: 'Title',
    titlePlaceholder: 'Title',
    centerLat: 'Latitude',
    centerLatPlaceholder: 'Latitude',
    centerLng: 'Longitude',
    centerLngPlaceholder: 'Longitude',
    zoom: 'Zoom Level',
    zoomPlaceholder: 'Zoom (1-20)',
    maxBoundsSwLat: 'SW Latitude',
    maxBoundsSwLatPlaceholder: 'SW Latitude',
    maxBoundsSwLng: 'SW Longitude',
    maxBoundsSwLngPlaceholder: 'SW Longitude',
    maxBoundsNeLat: 'NE Latitude',
    maxBoundsNeLatPlaceholder: 'NE Latitude',
    maxBoundsNeLng: 'NE Longitude',
    maxBoundsNeLngPlaceholder: 'NE Longitude',
    tabs: {
      general: 'General',
      mapSettings: 'Map Settings',
      pointGroups: 'Point Groups',
    },
    pointGroups: {
      title: 'Title',
      objectCode: 'Object',
      addPointGroup: 'Add Point Group',
    },
    cancelButton: 'Cancel',
    saveButton: 'Save',
  },
  addPointGroupDialog: {
    create: 'Create Point Group',
    edit: 'Edit Point Group',
    internalId: 'Internal ID',
    internalIdPlaceholder: 'Point Group Internal ID',
    title: 'Title',
    titlePlaceholder: 'Point Group Title',
    objectCode: 'Object',
    objectCodePlaceholder: 'Select Object',
    latitudeField: 'Latitude',
    latitudeFieldPlaceholder: 'Field name for latitude',
    longitudeField: 'Longitude',
    longitudeFieldPlaceholder: 'Field name for longitude',
    label: 'Label',
    labelBindType: 'Bind Type',
    labelBindTypePlaceholder: 'Select bind type',
    labelPosition: 'Position',
    labelPositionPlaceholder: 'Select position',
    labelAlign: 'Alignment',
    labelAlignPlaceholder: 'Select alignment',
    labelJSValue: 'Label JS Value',
    editScript: 'Edit Script',
    command: 'Get Data Command',
    pointStyle: 'Point Style',
    color: 'Color',
    value: 'Value',
  },
  timeLinesCreateOrEdit: {
    header: 'New/Edit TimeLine',
    title: {
      label: 'Title',
      placeholder: 'Title',
    },
    id: {
      label: 'Internal Id',
      placeholder: 'Model Internal Id',
    },
    tab: {
      general: 'General',
      objectX: 'Object X',
      objectY: 'Object Y',
      mainObject: 'Main Object',
    },
    addColumn: 'Add column',
    addAction: 'Add action',
    objectY: {
      object: 'Object',
      chooseObject: 'Choose object',
      keyField: 'Key field',
      stepFieldErrors: {
        object: 'Object',
        keyField: 'Key Field',
        getDataCommand: 'Command',
      },
      preFilterHint:
        'Enter a format string [field] [predicate] [value], for example, name == Cancel',
      command: 'Command',
      tabs: {
        data: 'Data',
        columns: 'Columns',
        actions: 'Actions',
        restrictions: 'Restrictions',
      },
    },
    objectX: {
      startDateField: 'Start date field',
      endDateField: 'End date field',
      value: 'Value',
      view: 'View',
      keyField: 'Key field',
      linkToObjectY: 'Link to Object Y',
      linkToObjectX: 'Link to Object X',
      linkDataBlock: {
        objectX: 'Object X data',
        links: 'Links',
        toObjectY: 'Object Y',
        toColumnsObject: 'Columns Object',
        fromColumnsObject: 'From Columns Object',
        fromObjectY: 'From Object Y',
        columnsObject: 'Columns Object',
        columnsObjectHint:
          'This data will be used for column display. The actual data will be fetched from the Object X command.',
        columnsObjectNotSelected: 'To fill this field, you need to select a columns object first',
        goToColumnsObject: 'Go to Columns Object',
        headerBlockLegend: 'Header Title',
        bindType: 'BindType',
        headerField: 'Field',
        objectYNotSelected: 'To fill this field, you need to select Object Y first',
        goToObjectY: 'Go to Object Y',
      },
      title: 'Title',
      cell: {
        width: 'Cell Width',
        height: 'Cell Height',
        minWidth: 'Min Width',
        minHeight: 'Min Height',
        previewSettings: 'Preview Settings',
        previewColumns: 'Preview Columns',
        previewRows: 'Preview Rows',
        cellPreview: 'Cell Preview',
        applyToConfig: 'Apply to config',
        scriptRequired: 'This field is required',
      },
      tabs: {
        data: 'Data',
        columns: 'Columns',
        cell: 'Cell',
        totals: 'Totals',
      },
      stepFieldErrors: {
        object: 'Object',
        linkToObjectY: 'Link To Object Y',
        startDateField: 'Start Date Field',
        endDateField: 'End Date Field',
        getDataCommand: 'Command',
        cell: {
          bindType: 'Cell Bind Type',
          entity: 'Cell View',
          value: 'Cell Value',
          width: 'Cell Width',
          height: 'Cell Height',
        },
        totals: {
          row: 'Totals Row',
        },
      },
      columns: {
        widthMaxValue: `Should be greater than {{minWidth}} and less than or equal to {{maxWidth}}`,
      },
      totals: {
        row: 'Row',
        addRow: 'Add row',
        deleteRow: 'Delete Row',
        rowTitle: 'Row Title',
        title: 'Title',
      },
    },
    general: {
      stepFieldErrors: {
        code: 'Code',
        title: 'Title',
      },
      mode: 'Mode',
      selectMode: 'Select mode',
      link: 'Link',
      selectLink: 'Select link',
      dateRange: 'Time Interval',
      showTimeIntervalFilter: 'Show filter',
      showUpdateButton: 'Show update button',
      showDayOfWeek: 'Show day of week',
      searchAssistant: 'Search Assistant',
      selectSearchAssistant: 'Select a search assistant',
      searchLegend: 'Search',
      filterColumnsObjectByObjectX: 'Filter Columns Object by Object X',
      filterObjectYByObjectX: 'Filter Object Y by Object X',
      tabs: {
        data: 'Data',
        actions: 'Actions',
        variables: 'Variables',
      },
    },
    mainObject: {
      objectType: 'Object Type',
      grouping: 'Grouping',
      groupField: 'Field',
      groupTitleType: 'Title Type',
      groupTitleScript: 'Title Script',
      groupTitleDisplayField: 'Display Field',
    },
    cancelButton: 'Cancel',
    saveButton: 'Save',
    applyButton: 'Apply',
    returnToTimeline: 'Return to TimeLine',
    footerConfigInfo: 'Config: {{title}} (code: {{code}})',
  },
  listenerConfig: {
    createEventFlow: '+ Create Event Flow',
    editEventFlow: 'Edit Event Flow',
    delete: 'Delete',
    cancel: 'Cancel',
    save: 'Save',
    id: 'ID',
    eventCode: 'Event Code',
    idAlreadyTaken: 'This ID is already taken',
    flowIdExists: 'A flow with this ID already exists',
    deleteEventFlowTitle: 'Delete Event Flow?',
    deleteEventFlowText:
      'Are you sure you want to delete this Event Flow? This action cannot be undone.',
    edit: 'Edit',
    addAction: 'Add Action',
  },
  map: {
    controls: {
      switchMode: 'Switch Mode',
    },
  },
  vectorIconPicker: {
    search: 'Search',
    title: 'Icon Picker',
    libraries: {
      all: 'All',
    },
    categories: {
      all: 'All',
    },
    category: 'Category',
    library: 'Library',
    select: 'Select',
    clear: 'Clear',
    size: 'Size',
  },
  websocketExpire: {
    onExpireInfo: 'This page is out of date. Please refresh the page.',
    refresh: 'Refresh',
  },
}
